import { useTranslation } from 'react-i18next';

import Typography from '../../components/Typography';
import { i18nNS } from '../../i18n';
import BellIcon from '../../icons/BellIcon';
import ChevronRightIcon from '../../icons/ChevronRightIcon';
import { ListItem, ListItemButton, ListItemIcon, ListItemText } from '../styles';
import ManageNotificationsDrawer from './ManageNotificationsDrawer';
import useManageNotificationsVM from './vm';

const ManageNotifications = () => {
  const { t } = useTranslation([i18nNS.SETTINGS]);

  const { isManageNotificationsDrawerOpen, handleCloseManageNotificationsDrawer, handleManageNotifications } =
    useManageNotificationsVM();

  return (
    <ListItem disableGutters disablePadding>
      <ListItemButton
        id="open-manage-notifications-drawer"
        onClick={handleManageNotifications}
        aria-label={t('click_to_manage_notifications', { ns: i18nNS.SETTINGS })}
        aria-haspopup="dialog"
      >
        <ListItemIcon>
          <BellIcon aria-hidden />
        </ListItemIcon>
        <ListItemText>
          <Typography variant="h6Regular" component="div">
            {t('manage_notifications', { ns: i18nNS.SETTINGS })}
          </Typography>
        </ListItemText>
        <ChevronRightIcon aria-hidden color="disabled" />
      </ListItemButton>
      <ManageNotificationsDrawer
        open={isManageNotificationsDrawerOpen}
        onClose={handleCloseManageNotificationsDrawer}
      />
    </ListItem>
  );
};

export default ManageNotifications;
